import { render, staticRenderFns } from "./companyInformation.vue?vue&type=template&id=523bc1f6&scoped=true&"
import script from "./companyInformation.vue?vue&type=script&lang=js&"
export * from "./companyInformation.vue?vue&type=script&lang=js&"
import style0 from "./companyInformation.vue?vue&type=style&index=0&id=523bc1f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523bc1f6",
  null
  
)

export default component.exports